import { AxiosInstance } from 'axios'

import { RawValidResponse } from '@percent/workplace-giving/api/goodstack'
import { Account } from '@percent/workplace-giving/context/auth/authContext/AuthContext.types'

type UpdateAccountParams = {
  fullName?: string
  preferredName?: string
  /** RFC 5646 language tag, e.g. "en-US" */
  preferredLanguage?: string
  phoneNumber?: string | null
}

export const updateAccount = async (client: AxiosInstance, params: UpdateAccountParams) => {
  const { data } = await client.patch<RawValidResponse<Account>>('v1/account', params, {
    withCredentials: true
  })

  return data.data
}
